import { render } from "./shopping-cart-checkout.vue?vue&type=template&id=c04fabc4&ts=true"
import script from "./shopping-cart-checkout.vue?vue&type=script&lang=ts"
export * from "./shopping-cart-checkout.vue?vue&type=script&lang=ts"

import "./shopping-cart-checkout.vue?vue&type=style&index=0&id=c04fabc4&lang=css"

import exportComponent from "C:\\Users\\claus\\source\\repos\\Joni\\SelfService\\JoniSelfService\\JoniSelfServicePortalUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__